import standardAPI from '@/api/standard_items';

const state = {
  category_types: [],
  category_types_status: '',
  category_types_MetaData: {},
  category_types_page: 1,
  category_types_perPage: 10,
};

const responseUrl = '/world-tours/category-types';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_category_types ({ commit }, getOptions) {
    commit('CATEGORY_TYPES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('CATEGORY_TYPES_SUCCESS', response);
            commit('CATEGORY_TYPES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('CATEGORY_TYPES_READY');
            reject(response);
          } else {
            commit('CATEGORY_TYPES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_category_type ({ commit, dispatch }, itemData) {
    commit('CATEGORY_TYPES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('CATEGORY_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  edit_category_type ({ commit, dispatch }, itemData) {
    commit('CATEGORY_TYPES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('CATEGORY_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  remove_category_type ({ commit, dispatch }, itemData) {
    commit('CATEGORY_TYPES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('CATEGORY_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_category_type ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_category_type_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.category_types_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.category_types_perPage = max;
  },
  CATEGORY_TYPES_READY: (state) => {
    state.category_types_status = 'ready';
  },
  CATEGORY_TYPES_REQUEST: (state) => {
    state.category_types_status = 'loading';
  },
  CATEGORY_TYPES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.category_types_MetaData.meta = response.meta;
      state.category_types_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.category_types = response.data.map((category) => {
        category.checked = false; // need for some pages where we can select category_types
        return category;
      }) || [];
    }
    state.category_types_status = 'success';
  },
  CATEGORY_TYPES_ERROR: (state) => {
    state.category_types_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
